module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lTL2Q"))).then(() => module.bundle.root('dJXJK'));